import { baseApi } from 'app/baseApi';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const apiPrefix = 'bundle';

export const activityBundleApi = baseApi.injectEndpoints({
	reducerPath: 'activityBundleApi',
	baseQuery: baseQuery,
	endpoints: (builder) => ({
		getAllBundles: builder.query({
			query: () => `${apiPrefix}`,
			providesTags: [apiTags.BUNDLE]
		}),
		getBundleById: builder.query({
			query: (id) => `${apiPrefix}/${id}`,
			providesTags: [apiTags.BUNDLE]
		}),
		addBundle: builder.mutation({
			query: (bundle) => ({
				url: `${apiPrefix}`,
				method: 'POST',
				body: bundle
			}),
			invalidatesTags: [apiTags.BUNDLE]
		}),
		updateBundle: builder.mutation({
			query: (bundle) => ({
				url: `${apiPrefix}/update`,
				method: 'PUT',
				body: bundle
			}),
			invalidatesTags: [apiTags.BUNDLE]
		}),
		deleteBundle: builder.mutation({
			query: (bundle) => ({
				url: `${apiPrefix}/delete`,
				method: 'PUT',
				body: bundle
			}),
			invalidatesTags: [apiTags.BUNDLE]
		})
	})
});

export const {
	useGetAllBundlesQuery,
	useGetBundleByIdQuery,
	useAddBundleMutation,
	useUpdateBundleMutation,
	useDeleteBundleMutation
} = activityBundleApi;
